import React from "react"
import { graphql } from "gatsby"
import { ModalRoutingContext } from "gatsby-plugin-modal-routing"
import ReactMarkdownWithHtml from "react-markdown/with-html"
import style from "./section.module.scss"
import Layout from "../../../components/layout"
import Modal from "../../../components/modal"
import SEO from "../../../components/seo"
import Video from "../../../components/Video"

const share = (title, desciption, url) => {
  const shareData = {
    title: title,
    text: desciption,
    url: url,
  }
  try {
    navigator.share(shareData)
    return true
  } catch (ex) {
    return false
  }
}

const Section = props => {
  const writing = {}
  props.data.allStrapiWriting.edges.forEach(element => {
    writing[element.node.key] = element.node.writing
  })
  const section = props.data.allStrapiSession.nodes[0]
  const startTime = new Date(section.start_time)
  const endTime = new Date(section.end_time)
  const content = (
    <>
      <div className={style.head + " " + (section.stream ? style.video : "")}>
        {section.stream ? (
          <div style={{ maxWidth: 720, width: "100%" }}>
            <div className={style.videoWrap}>
              <Video name={section.name} writing={writing} stream={section.stream} />
            </div>
          </div>
        ) : (
          <svg
            width="302px"
            height="301px"
            viewBox="0 0 302 301"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <radialGradient
                cx="50%"
                cy="50%"
                fx="50%"
                fy="50%"
                r="43.0665319%"
                gradientTransform="translate(0.500000,0.500000),scale(1.000000,0.994536),rotate(92.756543),translate(-0.500000,-0.500000)"
                id="radialGradient-1"
              >
                <stop stopColor="#FF9292" offset="0%"></stop>
                <stop
                  stopColor="#FFB0B0"
                  stopOpacity="0.0359211101"
                  offset="100%"
                ></stop>
              </radialGradient>
              <filter
                x="-57.7%"
                y="-57.4%"
                width="215.4%"
                height="214.8%"
                filterUnits="objectBoundingBox"
                id="filter-2"
              >
                <feGaussianBlur
                  stdDeviation="35"
                  in="SourceGraphic"
                ></feGaussianBlur>
              </filter>
            </defs>
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g id="議程_mobile" transform="translate(-36.000000, -33.000000)">
                <g id="Group-5" transform="translate(94.757143, 92.000000)">
                  <ellipse
                    id="Oval"
                    fill="url(#radialGradient-1)"
                    filter="url(#filter-2)"
                    transform="translate(92.242857, 91.500000) rotate(90.000000) translate(-92.242857, -91.500000) "
                    cx="92.2428571"
                    cy="91.5"
                    rx="91"
                    ry="91.5"
                  ></ellipse>
                  <g
                    id="Group"
                    transform="translate(35.242857, 41.000000)"
                    fill="#FFFFFF"
                  >
                    <path
                      d="M66.8097703,85.4644691 C70.1874296,85.4644691 73.0622304,88.3861917 73.8857975,92.4471375 L73.9101246,92.5705433 L72.9451131,92.7529095 C72.2362056,89.0506946 69.6979514,86.440342 66.8097703,86.440342 C63.3480455,86.440342 60.4820165,90.1607225 60.4820165,94.8040069 C60.4820165,95.3611074 60.5233709,95.9109678 60.6047195,96.448232 L60.6303226,96.609028 L59.661264,96.7688169 C59.5541663,96.1278031 59.4997002,95.4703094 59.4997002,94.8040069 C59.4997002,89.6700825 62.7395329,85.4644691 66.8097703,85.4644691 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(66.704912, 91.116643) rotate(30.000000) translate(-66.704912, -91.116643) "
                    ></path>
                    <path
                      d="M57.9785703,84.2452694 C58.0893911,84.0013356 58.382914,83.8908074 58.6341721,83.9983976 C58.8854302,84.1059879 58.9992772,84.3909545 58.8884564,84.6348883 C58.2026662,86.1444198 57.8396072,87.8219259 57.8396072,89.5599013 C57.8396072,90.3420694 57.913072,91.1131523 58.0573783,91.8641329 C58.1077399,92.1262184 57.9297244,92.3783166 57.6597696,92.4272102 C57.3898148,92.4761037 57.1301471,92.3032775 57.0797855,92.041192 C56.9242602,91.2318266 56.8451484,90.4014728 56.8451484,89.5599013 C56.8451484,87.687953 57.2369294,85.8777369 57.9785703,84.2452694 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(57.888008, 88.196353) rotate(30.000000) translate(-57.888008, -88.196353) "
                    ></path>
                    <path
                      d="M66.5244565,88.8557734 C68.4138678,88.8557734 69.9828346,90.597652 70.4047906,92.9765694 C70.4396418,93.1730548 70.4663853,93.3725552 70.4848427,93.5743502 L70.4971293,93.7261154 L69.5161303,93.7944411 C69.5006438,93.5747587 69.4739254,93.3582853 69.4363228,93.146288 C69.0891476,91.1889722 67.8680126,89.833259 66.5244565,89.833259 C64.906792,89.833259 63.5168781,91.7810159 63.5168781,94.2482357 C63.5168781,94.5776977 63.5417864,94.9022978 63.5906698,95.2181536 C63.604478,95.3073742 63.6201876,95.3958175 63.6377667,95.4833862 L63.6655337,95.6140708 L62.7056973,95.8267879 C62.671767,95.675523 62.6427321,95.5220638 62.6186989,95.3667754 C62.5621946,95.0016781 62.5334738,94.6273925 62.5334738,94.2482357 C62.5334738,91.2989566 64.2769224,88.8557734 66.5244565,88.8557734 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(66.515302, 92.341281) rotate(30.000000) translate(-66.515302, -92.341281) "
                    ></path>
                    <path
                      d="M65.8516636,91.6818604 C66.668549,91.6818604 67.2705218,92.480818 67.4250031,93.5220101 C67.4504214,93.6933274 67.4633558,93.8696323 67.4633558,94.0483742 C67.4633558,94.1946565 67.4546926,94.3393035 67.4376147,94.4809146 L67.4232324,94.5865317 L66.4668754,94.445435 C66.486345,94.3172785 66.4963405,94.1841428 66.4963405,94.0483742 C66.4963405,93.9156376 66.4867865,93.7854101 66.4681615,93.6598791 C66.3746713,93.0297623 66.0771021,92.634819 65.8516636,92.634819 C65.564123,92.634819 65.2069867,93.2331252 65.2069867,94.0483742 C65.2069867,94.1648184 65.2143391,94.2793636 65.2287333,94.3905511 C65.2503241,94.5573295 65.2875213,94.7146249 65.3379575,94.8564991 L65.3603767,94.9163408 L64.4590481,95.2615705 C64.3680703,95.0309 64.3039437,94.7772658 64.2694926,94.5111488 C64.2499093,94.3598774 64.2399714,94.205052 64.2399714,94.0483742 C64.2399714,92.7759487 64.893046,91.6818604 65.8516636,91.6818604 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(65.851664, 93.471715) rotate(30.000000) translate(-65.851664, -93.471715) "
                    ></path>
                    <path
                      d="M60.8269761,28.7543242 C65.695796,28.7543242 70.4658898,29.1069794 75.0195841,29.7923874 L75.3694395,29.845767 L75.2183055,30.8096938 C70.6096386,30.0970055 65.770355,29.7298667 60.8269761,29.7298667 C35.051206,29.7298667 14.2169512,39.7229554 14.2169512,51.8340343 C14.2169512,63.9451132 35.051206,73.9382019 60.8269761,73.9382019 C86.6027463,73.9382019 107.437001,63.9451132 107.437001,51.8340343 C107.437001,42.9331441 96.0497514,34.8985431 78.8760277,31.4577494 L78.3538464,31.3548929 L78.541812,30.3973772 C96.4137739,33.8576529 108.419299,42.2346541 108.419299,51.8340343 C108.419299,64.6773221 87.0777259,74.9137445 60.8269761,74.9137445 C34.5762264,74.9137445 13.2346535,64.6773221 13.2346535,51.8340343 C13.2346535,38.9907466 34.5762264,28.7543242 60.8269761,28.7543242 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(60.826976, 51.834034) rotate(30.000000) translate(-60.826976, -51.834034) "
                    ></path>
                    <path
                      d="M61.0910911,32.8992517 C83.6381896,32.8992517 101.97253,41.1867791 101.97253,51.6456285 C101.97253,62.1044779 83.6381896,70.3920053 61.0910911,70.3920053 C41.3510666,70.3920053 24.5404105,63.9954239 20.9246078,55.180724 L20.8190874,54.9128759 L21.7383268,54.5684872 C24.9344733,63.0291443 41.5171023,69.4139335 61.0910911,69.4139335 C83.157964,69.4139335 100.990393,61.353281 100.990393,51.6456285 C100.990393,41.937976 83.157964,33.8773235 61.0910911,33.8773235 C42.8948594,33.8773235 27.1620772,39.4015567 22.5359925,47.0908643 L22.3992167,47.3245329 L21.5447714,46.8422691 C26.2074803,38.6494084 42.394279,32.8992517 61.0910911,32.8992517 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(61.395809, 51.645629) rotate(30.000000) translate(-61.395809, -51.645629) "
                    ></path>
                    <path
                      d="M61.7750304,37.0441792 C71.1142866,37.0441792 79.7931268,38.8764113 85.753497,42.004643 L85.93328,42.0998341 L85.4689197,42.9619033 C79.6585326,39.8582121 71.0564973,38.0224401 61.7750304,38.0224401 C44.7990014,38.0224401 31.0923874,44.1445534 31.0923874,51.4572227 C31.0923874,58.7698921 44.7990014,64.8920053 61.7750304,64.8920053 C78.7510594,64.8920053 92.4576733,58.7698921 92.4576733,51.4572227 C92.4576733,49.4137118 91.3845444,47.4147782 89.3224933,45.5810948 L89.2371949,45.5058313 L89.8858525,44.7711552 C92.2000455,46.7973428 93.4400418,49.0751939 93.4400418,51.4572227 C93.4400418,59.524483 79.2326601,65.8702662 61.7750304,65.8702662 C44.3174007,65.8702662 30.1100189,59.524483 30.1100189,51.4572227 C30.1100189,43.3899624 44.3174007,37.0441792 61.7750304,37.0441792 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(61.775030, 51.457223) rotate(30.000000) translate(-61.775030, -51.457223) "
                    ></path>
                    <path
                      d="M61.7750304,43.0731647 C72.0063317,43.0731647 80.3568934,46.8476422 80.3568934,51.7398314 C80.3568934,56.6320206 72.0063317,60.4064981 61.7750304,60.4064981 C60.3637022,60.4064981 58.9730343,60.334314 57.6216512,60.192699 L57.3326772,60.1612913 L57.4433027,59.1872922 C58.8482222,59.3454824 60.2997101,59.4262907 61.7750304,59.4262907 C71.5249807,59.4262907 79.3724238,55.8792243 79.3724238,51.7398314 C79.3724238,47.6004385 71.5249807,44.0533721 61.7750304,44.0533721 C52.0250801,44.0533721 44.1776369,47.6004385 44.1776369,51.7398314 C44.1776369,53.9441317 46.4456428,56.0842091 50.3687906,57.5632209 L50.4881799,57.6078365 L50.1449084,58.5265254 C45.8061995,56.9193578 43.1931674,54.4791119 43.1931674,51.7398314 C43.1931674,46.8476422 51.5437291,43.0731647 61.7750304,43.0731647 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(61.775030, 51.739831) rotate(30.000000) translate(-61.775030, -51.739831) "
                    ></path>
                    <path
                      d="M75.0064689,8.18721288 C75.2664117,8.18649639 75.4777178,8.39664079 75.4784342,8.65658354 C75.4784366,8.6574498 75.4784366,8.65831606 75.4784342,8.65918232 L75.3740822,46.3975816 C75.3733583,46.6593853 75.1613032,46.8714385 74.8994996,46.8721601 C74.6395568,46.8728766 74.4282507,46.6627322 74.4275342,46.4027894 C74.4275319,46.4019232 74.4275319,46.4010569 74.4275343,46.4001906 L74.5318863,8.66179133 C74.5326102,8.39998771 74.7446653,8.1879345 75.0064689,8.18721288 Z"
                      id="Rectangle"
                      transform="translate(74.952984, 27.529686) rotate(30.000000) translate(-74.952984, -27.529686) "
                    ></path>
                    <path
                      d="M89.1816248,-0.0762817257 C89.4415676,-0.0769982167 89.6528736,0.133146185 89.6535901,0.393088934 C89.6535925,0.393955194 89.6535925,0.394821459 89.6535901,0.395687719 L89.6405534,5.11035161 C89.6398295,5.37215523 89.4277744,5.58420844 89.1659707,5.58493006 C88.906028,5.58564655 88.6947219,5.37550215 88.6940054,5.1155594 C88.6940031,5.11469314 88.6940031,5.11382688 88.6940055,5.11296062 L88.7070422,0.398296729 C88.7077661,0.136493102 88.9198212,-0.0755601054 89.1816248,-0.0762817257 Z"
                      id="Rectangle"
                      transform="translate(89.173798, 2.754324) rotate(30.000000) translate(-89.173798, -2.754324) "
                    ></path>
                    <path
                      d="M24.524326,111.45995 C24.7842687,111.459234 24.9955748,111.669378 24.9962913,111.929321 C24.9962937,111.930187 24.9962937,111.931053 24.9962913,111.93192 L24.9832545,116.646583 C24.9825306,116.908387 24.7704755,117.12044 24.5086719,117.121162 C24.2487292,117.121878 24.0374231,116.911734 24.0367066,116.651791 C24.0367042,116.650925 24.0367042,116.650059 24.0367066,116.649193 L24.0497433,111.934529 C24.0504673,111.672725 24.2625223,111.460672 24.524326,111.45995 Z"
                      id="Rectangle"
                      transform="translate(24.516499, 114.290556) rotate(30.000000) translate(-24.516499, -114.290556) "
                    ></path>
                    <ellipse
                      id="Oval"
                      transform="translate(63.291917, 47.783310) rotate(30.000000) translate(-63.291917, -47.783310) "
                      cx="63.2919172"
                      cy="47.7833097"
                      rx="7.00448181"
                      ry="6.98218848"
                    ></ellipse>
                    <path
                      d="M26.8866345,26.4934546 C24.4780934,26.4934546 22.525585,28.433554 22.525585,30.8267879 C22.525585,33.2200219 24.4780934,35.1601213 26.8866345,35.1601213 C29.2951756,35.1601213 31.247684,33.2200219 31.247684,30.8267879 C31.247684,28.433554 29.2951756,26.4934546 26.8866345,26.4934546 Z M26.8866345,27.4636039 C28.75595,27.4636039 30.2713296,28.9693527 30.2713296,30.8267879 C30.2713296,32.6842232 28.75595,34.189972 26.8866345,34.189972 C25.017319,34.189972 23.5019394,32.6842232 23.5019394,30.8267879 C23.5019394,28.9693527 25.017319,27.4636039 26.8866345,27.4636039 Z"
                      id="Oval"
                      fillRule="nonzero"
                      transform="translate(26.886635, 30.826788) rotate(30.000000) translate(-26.886635, -30.826788) "
                    ></path>
                    <path
                      d="M87.9413273,54.7543242 C86.2658204,54.7543242 84.9075537,56.1039585 84.9075537,57.7688169 C84.9075537,59.4336753 86.2658204,60.7833097 87.9413273,60.7833097 C89.6168341,60.7833097 90.9751008,59.4336753 90.9751008,57.7688169 C90.9751008,56.1039585 89.6168341,54.7543242 87.9413273,54.7543242 Z M87.9413273,55.7319975 C89.0734265,55.7319975 89.9911743,56.6439126 89.9911743,57.7688169 C89.9911743,58.8937212 89.0734265,59.8056363 87.9413273,59.8056363 C86.809228,59.8056363 85.8914803,58.8937212 85.8914803,57.7688169 C85.8914803,56.6439126 86.809228,55.7319975 87.9413273,55.7319975 Z"
                      id="Oval"
                      fillRule="nonzero"
                      transform="translate(87.941327, 57.768817) rotate(30.000000) translate(-87.941327, -57.768817) "
                    ></path>
                    <path
                      d="M85.5711917,39.116643 C86.7754622,39.116643 87.7517164,40.0866927 87.7517164,41.2833097 C87.7517164,42.4799266 86.7754622,43.4499763 85.5711917,43.4499763 C84.3669211,43.4499763 83.3906669,42.4799266 83.3906669,41.2833097 C83.3906669,40.0866927 84.3669211,39.116643 85.5711917,39.116643 Z M85.5711917,40.0940866 C84.9102011,40.0940866 84.3743623,40.6265199 84.3743623,41.2833097 C84.3743623,41.9400994 84.9102011,42.4725327 85.5711917,42.4725327 C86.2321823,42.4725327 86.768021,41.9400994 86.768021,41.2833097 C86.768021,40.6265199 86.2321823,40.0940866 85.5711917,40.0940866 Z"
                      id="Oval"
                      fillRule="nonzero"
                      transform="translate(85.571192, 41.283310) rotate(30.000000) translate(-85.571192, -41.283310) "
                    ></path>
                    <path
                      d="M51.2516284,49.8557734 C49.000166,49.8557734 47.1749952,51.6693446 47.1749952,53.9064981 C47.1749952,56.1436515 49.000166,57.9572227 51.2516284,57.9572227 C53.5030907,57.9572227 55.3282616,56.1436515 55.3282616,53.9064981 C55.3282616,51.6693446 53.5030907,49.8557734 51.2516284,49.8557734 Z M51.2516284,50.8260069 C52.9638183,50.8260069 54.3518225,52.2051898 54.3518225,53.9064981 C54.3518225,55.6078064 52.9638183,56.9869893 51.2516284,56.9869893 C49.5394384,56.9869893 48.1514343,55.6078064 48.1514343,53.9064981 C48.1514343,52.2051898 49.5394384,50.8260069 51.2516284,50.8260069 Z"
                      id="Oval"
                      fillRule="nonzero"
                      transform="translate(51.251628, 53.906498) rotate(30.000000) translate(-51.251628, -53.906498) "
                    ></path>
                    <path
                      d="M35.359017,82.9951598 C35.6189598,82.9944433 35.8302659,83.2045877 35.8309824,83.4645304 C35.8309847,83.4653967 35.8309847,83.466263 35.8309823,83.4671292 L35.7642,107.61862 C35.7634761,107.880424 35.551421,108.092477 35.2896174,108.093199 C35.0296746,108.093915 34.8183686,107.883771 34.8176521,107.623828 C34.8176497,107.622962 34.8176497,107.622096 34.8176521,107.621229 L34.8844344,83.4697382 C34.8851583,83.2079346 35.0972134,82.9958814 35.359017,82.9951598 Z"
                      id="Rectangle"
                      transform="translate(35.324317, 95.544179) rotate(30.000000) translate(-35.324317, -95.544179) "
                    ></path>
                    <path
                      d="M0.564970237,63.9862082 C0.564970237,76.1467201 21.399225,86.1805969 47.1749952,86.1805969 C72.6930076,86.1805969 93.3678408,76.3463942 93.7787857,64.3503777 L93.7850201,63.9862082 L94.7673178,63.9862082 C94.7673178,76.8819176 73.4257449,87.1601213 47.1749952,87.1601213 C21.1867529,87.1601213 0.0099949314,77.0864538 -0.410941404,64.3722866 L-0.417327443,63.9862082 L0.564970237,63.9862082 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(47.174995, 75.573165) rotate(30.000000) translate(-47.174995, -75.573165) "
                    ></path>
                    <polygon
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(97.732259, 82.261571) rotate(30.000000) translate(-97.732259, -82.261571) "
                      points="98.2322588 73.9717155 98.2322588 90.5514256 97.2322588 90.5514256 97.2322588 73.9717155"
                    ></polygon>
                    <polygon
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(16.199595, 35.536933) rotate(30.000000) translate(-16.199595, -35.536933) "
                      points="16.6995946 27.2470778 16.6995946 43.8267879 15.6995946 43.8267879 15.6995946 27.2470778"
                    ></polygon>
                    <path
                      d="M15.2515403,53.6238894 C15.5178205,53.6238894 15.7354838,53.8271623 15.7506915,54.0834762 L15.7515403,54.1121662 L15.7515403,59.3530039 C15.7515403,59.6226717 15.5276827,59.8412807 15.2515403,59.8412807 C14.9852602,59.8412807 14.7675968,59.6380078 14.7523891,59.3816939 L14.7515403,59.3530039 L14.7515403,54.1121662 C14.7515403,53.8424984 14.9753979,53.6238894 15.2515403,53.6238894 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(15.251540, 56.732585) rotate(30.000000) translate(-15.251540, -56.732585) "
                    ></path>
                    <path
                      d="M88.6309381,84.1456285 C88.8972183,84.1456285 89.1148816,84.3495916 89.1300893,84.6067759 L89.1309381,84.6355633 L89.1309381,91.3803315 C89.1309381,91.6509149 88.9070805,91.8702662 88.6309381,91.8702662 C88.364658,91.8702662 88.1469946,91.6663031 88.1317869,91.4091188 L88.1309381,91.3803315 L88.1309381,84.6355633 C88.1309381,84.3649798 88.3547957,84.1456285 88.6309381,84.1456285 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(88.630938, 88.007947) rotate(30.000000) translate(-88.630938, -88.007947) "
                    ></path>
                    <path
                      d="M17.7164813,37.6093966 C17.9827615,37.6093966 18.2004248,37.8114251 18.2156325,38.06617 L18.2164813,38.0946843 L18.2164813,43.5299061 C18.2164813,43.797923 17.9926237,44.0151937 17.7164813,44.0151937 C17.4502012,44.0151937 17.2325378,43.8131653 17.2173301,43.5584204 L17.2164813,43.5299061 L17.2164813,38.0946843 C17.2164813,37.8266673 17.440339,37.6093966 17.7164813,37.6093966 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(17.716481, 40.812295) rotate(30.000000) translate(-17.716481, -40.812295) "
                    ></path>
                    <path
                      d="M53.3633206,73.9717155 C53.6296007,73.9717155 53.847264,74.1763274 53.8624718,74.4343299 L53.8633206,74.4632089 L53.8633206,84.7845699 C53.8633206,85.0560142 53.6394629,85.2760633 53.3633206,85.2760633 C53.0970404,85.2760633 52.8793771,85.0714513 52.8641694,84.8134489 L52.8633206,84.7845699 L52.8633206,74.4632089 C52.8633206,74.1917646 53.0871782,73.9717155 53.3633206,73.9717155 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(53.363321, 79.623889) rotate(30.000000) translate(-53.363321, -79.623889) "
                    ></path>
                    <path
                      d="M27.0762454,62.1021503 C25.9795376,62.1021503 25.1801369,63.3149065 25.1801369,64.7398314 C25.1801369,66.1647563 25.9795376,67.3775126 27.0762454,67.3775126 C28.1729531,67.3775126 28.9723538,66.1647563 28.9723538,64.7398314 C28.9723538,63.3149065 28.1729531,62.1021503 27.0762454,62.1021503 Z M27.0762454,63.0943814 C27.5387865,63.0943814 28.0034067,63.7992483 28.0034067,64.7398314 C28.0034067,65.6804145 27.5387865,66.3852814 27.0762454,66.3852814 C26.6137043,66.3852814 26.1490841,65.6804145 26.1490841,64.7398314 C26.1490841,63.7992483 26.6137043,63.0943814 27.0762454,63.0943814 Z"
                      id="Oval"
                      fillRule="nonzero"
                      transform="translate(27.076245, 64.739831) rotate(30.000000) translate(-27.076245, -64.739831) "
                    ></path>
                    <path
                      d="M27.1710508,59.6528749 C24.7917886,59.6528749 22.9048067,61.9490496 22.9048067,64.7398314 C22.9048067,67.5306133 24.7917886,69.8267879 27.1710508,69.8267879 C29.550313,69.8267879 31.4372949,67.5306133 31.4372949,64.7398314 C31.4372949,61.9490496 29.550313,59.6528749 27.1710508,59.6528749 Z M27.1710508,60.6374471 C28.9625008,60.6374471 30.4565491,62.4554805 30.4565491,64.7398314 C30.4565491,67.0241824 28.9625008,68.8422157 27.1710508,68.8422157 C25.3796008,68.8422157 23.8855525,67.0241824 23.8855525,64.7398314 C23.8855525,62.4554805 25.3796008,60.6374471 27.1710508,60.6374471 Z"
                      id="Oval"
                      fillRule="nonzero"
                      transform="translate(27.171051, 64.739831) rotate(30.000000) translate(-27.171051, -64.739831) "
                    ></path>
                    <path
                      d="M30.1362721,59.9846195 C30.22323,59.7286243 30.5003388,59.5919029 30.755212,59.6792436 C33.3962284,60.5842754 35.2295118,63.488625 35.2295118,66.8102521 C35.2295118,67.8599578 35.1546077,68.7760844 34.9834214,69.6228054 C34.9298298,69.8878799 34.6724417,70.0591295 34.408529,70.005302 C34.1446162,69.9514745 33.9741172,69.6929533 34.0277088,69.4278787 C34.1845564,68.6520797 34.2542936,67.7991484 34.2542936,66.8102521 C34.2542936,63.8875866 32.6640932,61.3683373 30.4403095,60.6062841 C30.1854364,60.5189434 30.0493142,60.2406147 30.1362721,59.9846195 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(32.669765, 64.834034) rotate(30.000000) translate(-32.669765, -64.834034) "
                    ></path>
                    <path
                      d="M22.6752634,56.4425107 C22.849056,56.2338775 23.1650611,56.2008165 23.3810804,56.3686668 C23.5970997,56.5365171 23.6313312,56.8417173 23.4575386,57.0503505 C22.2976064,58.4428163 21.633492,60.3145559 21.633492,62.3143256 C21.633492,64.5648763 22.475881,66.6477488 23.900286,68.061828 C24.093617,68.2537575 24.0892449,68.5607141 23.8905206,68.7474348 C23.6917962,68.9341554 23.3739726,68.9299327 23.1806416,68.7380032 C21.5704056,67.1394401 20.6294766,64.8129197 20.6294766,62.3143256 C20.6294766,60.0963236 21.3698703,58.0095983 22.6752634,56.4425107 Z"
                      id="Path"
                      fillRule="nonzero"
                      transform="translate(22.335974, 62.573165) rotate(30.000000) translate(-22.335974, -62.573165) "
                    ></path>
                    <path
                      d="M46.5373301,76.4209908 C46.8036102,76.4209908 47.0212736,76.6249539 47.0364813,76.8821382 L47.0373301,76.9109256 L47.0373301,83.6556938 C47.0373301,83.9262773 46.8134725,84.1456285 46.5373301,84.1456285 C46.2710499,84.1456285 46.0533866,83.9416654 46.0381789,83.6844812 L46.0373301,83.6556938 L46.0373301,76.9109256 C46.0373301,76.6403421 46.2611877,76.4209908 46.5373301,76.4209908 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(46.537330, 80.283310) rotate(30.000000) translate(-46.537330, -80.283310) "
                    ></path>
                    <path
                      d="M79.9088392,85.8412807 C80.1724296,85.8412807 80.3883804,85.9743484 80.4074677,86.1431315 L80.4088392,86.1674758 L80.4088392,96.4426218 C80.4088392,96.6227744 80.1849815,96.7688169 79.9088392,96.7688169 C79.6452487,96.7688169 79.4292979,96.6357492 79.4102106,96.4669661 L79.4088392,96.4426218 L79.4088392,86.1674758 C79.4088392,85.9873232 79.6326968,85.8412807 79.9088392,85.8412807 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(79.908839, 91.305049) rotate(30.000000) translate(-79.908839, -91.305049) "
                    ></path>
                    <path
                      d="M20.3710332,51.3630198 C20.6373133,51.3630198 20.8549767,51.5669829 20.8701844,51.8241672 L20.8710332,51.8529546 L20.8710332,58.5977228 C20.8710332,58.8683062 20.6471756,59.0876575 20.3710332,59.0876575 C20.104753,59.0876575 19.8870897,58.8836944 19.871882,58.6265102 L19.8710332,58.5977228 L19.8710332,51.8529546 C19.8710332,51.5823711 20.0948908,51.3630198 20.3710332,51.3630198 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(20.371033, 55.225339) rotate(30.000000) translate(-20.371033, -55.225339) "
                    ></path>
                    <path
                      d="M36.8671769,66.6238894 C37.133457,66.6238894 37.3511204,66.8278525 37.3663281,67.0850367 L37.3671769,67.1138241 L37.3671769,73.8585923 C37.3671769,74.1291758 37.1433193,74.3485271 36.8671769,74.3485271 C36.6008967,74.3485271 36.3832334,74.144564 36.3680257,73.8873797 L36.3671769,73.8585923 L36.3671769,67.1138241 C36.3671769,66.8432406 36.5910345,66.6238894 36.8671769,66.6238894 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(36.867177, 70.486208) rotate(30.000000) translate(-36.867177, -70.486208) "
                    ></path>
                    <path
                      d="M36.1087335,76.0441792 C36.3750136,76.0441792 36.592677,76.2490984 36.6078847,76.5074883 L36.6087335,76.5364106 L36.6087335,81.015716 C36.6087335,81.2875679 36.3848759,81.5079474 36.1087335,81.5079474 C35.8424533,81.5079474 35.62479,81.3030282 35.6095823,81.0446383 L35.6087335,81.015716 L35.6087335,76.5364106 C35.6087335,76.2645587 35.8325911,76.0441792 36.1087335,76.0441792 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(36.108733, 78.776063) rotate(30.000000) translate(-36.108733, -78.776063) "
                    ></path>
                    <path
                      d="M40.2801721,74.5369329 C40.5464523,74.5369329 40.7641156,74.7405611 40.7793233,74.9973232 L40.7801721,75.0260633 L40.7801721,79.134759 C40.7801721,79.4048982 40.5563145,79.6238894 40.2801721,79.6238894 C40.013892,79.6238894 39.7962286,79.4202611 39.7810209,79.1634991 L39.7801721,79.134759 L39.7801721,75.0260633 C39.7801721,74.755924 40.0040298,74.5369329 40.2801721,74.5369329 Z"
                      id="Path-2"
                      fillRule="nonzero"
                      transform="translate(40.280172, 77.080411) rotate(30.000000) translate(-40.280172, -77.080411) "
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        )}
      </div>
      <div className={style.content}>
        <div className={style.label}>議程主題</div>
        <h1
          dangerouslySetInnerHTML={{
            __html:
              section.name && section.name.replace(/(?:\r\n|\r|\n)/g, "<br/>"),
          }}
        ></h1>
        <div className={style.label}>
          <svg
            width="18px"
            height="19px"
            viewBox="0 0 18 19"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            style={{ verticalAlign: "top" }}
          >
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="議程_web"
                transform="translate(-373.000000, -490.000000)"
                fillRule="nonzero"
              >
                <g
                  id="fa-calendar-o"
                  transform="translate(373.000000, 490.000000)"
                >
                  <g id="Icon" fill="#000000">
                    <path
                      d="M1.38461538,17.6428571 L16.6153846,17.6428571 L16.6153846,6.78571429 L1.38461538,6.78571429 L1.38461538,17.6428571 Z M5.53846154,4.75 L5.53846154,1.69642857 C5.53846154,1.59747024 5.50600962,1.51618304 5.44110577,1.45256696 C5.37620192,1.38895089 5.29326923,1.35714286 5.19230769,1.35714286 L4.5,1.35714286 C4.39903846,1.35714286 4.31610577,1.38895089 4.25120192,1.45256696 C4.18629808,1.51618304 4.15384615,1.59747024 4.15384615,1.69642857 L4.15384615,4.75 C4.15384615,4.84895833 4.18629808,4.93024554 4.25120192,4.99386161 C4.31610577,5.05747768 4.39903846,5.08928571 4.5,5.08928571 L5.19230769,5.08928571 C5.29326923,5.08928571 5.37620192,5.05747768 5.44110577,4.99386161 C5.50600962,4.93024554 5.53846154,4.84895833 5.53846154,4.75 Z M13.8461538,4.75 L13.8461538,1.69642857 C13.8461538,1.59747024 13.8137019,1.51618304 13.7487981,1.45256696 C13.6838942,1.38895089 13.6009615,1.35714286 13.5,1.35714286 L12.8076923,1.35714286 C12.7067308,1.35714286 12.6237981,1.38895089 12.5588942,1.45256696 C12.4939904,1.51618304 12.4615385,1.59747024 12.4615385,1.69642857 L12.4615385,4.75 C12.4615385,4.84895833 12.4939904,4.93024554 12.5588942,4.99386161 C12.6237981,5.05747768 12.7067308,5.08928571 12.8076923,5.08928571 L13.5,5.08928571 C13.6009615,5.08928571 13.6838942,5.05747768 13.7487981,4.99386161 C13.8137019,4.93024554 13.8461538,4.84895833 13.8461538,4.75 Z M18,4.07142857 L18,17.6428571 C18,18.0104167 17.8629808,18.328497 17.5889423,18.5970982 C17.3149038,18.8656994 16.9903846,19 16.6153846,19 L1.38461538,19 C1.00961538,19 0.685096154,18.8656994 0.411057692,18.5970982 C0.137019231,18.328497 0,18.0104167 0,17.6428571 L0,4.07142857 C0,3.70386905 0.137019231,3.38578869 0.411057692,3.1171875 C0.685096154,2.84858631 1.00961538,2.71428571 1.38461538,2.71428571 L2.76923077,2.71428571 L2.76923077,1.69642857 C2.76923077,1.22991071 2.93870192,0.830543155 3.27764423,0.498325893 C3.61658654,0.166108631 4.02403846,0 4.5,0 L5.19230769,0 C5.66826923,0 6.07572115,0.166108631 6.41466346,0.498325893 C6.75360577,0.830543155 6.92307692,1.22991071 6.92307692,1.69642857 L6.92307692,2.71428571 L11.0769231,2.71428571 L11.0769231,1.69642857 C11.0769231,1.22991071 11.2463942,0.830543155 11.5853365,0.498325893 C11.9242788,0.166108631 12.3317308,0 12.8076923,0 L13.5,0 C13.9759615,0 14.3834135,0.166108631 14.7223558,0.498325893 C15.0612981,0.830543155 15.2307692,1.22991071 15.2307692,1.69642857 L15.2307692,2.71428571 L16.6153846,2.71428571 C16.9903846,2.71428571 17.3149038,2.84858631 17.5889423,3.1171875 C17.8629808,3.38578869 18,3.70386905 18,4.07142857 Z"
                      id="Icon-Shape"
                    ></path>
                  </g>
                  <rect id="ViewBox" x="0" y="0" width="18" height="19"></rect>
                </g>
              </g>
            </g>
          </svg>
          {` ${
            startTime.getMonth() + 1
          }/${startTime.getDate()} ${startTime.getHours()}:${startTime
            .getMinutes()
            .toString()
            .padStart(
              2,
              "0"
            )} ~ ${endTime.getHours()}:${endTime
            .getMinutes()
            .toString()
            .padStart(2, "0")} ${section.location}`}
        </div>
        <ReactMarkdownWithHtml
          allowDangerousHtml={true}
          children={section.description}
        ></ReactMarkdownWithHtml>
        {section.speakers.length > 0 && (
          <>
            <div className={style.label}>介紹</div>
            {section.speakers[0].avatar && (
              <div className={style.avatar}>
                <img
                  src={section.speakers[0].avatar.childImageSharp.resize.src}
                  alt={section.speakers[0].name.name}
                />
              </div>
            )}
            <h3 style={{ margin: "1.5rem 0 1rem 0" }}>
              {section.speakers[0].name.name}
            </h3>
            <div>{section.speakers[0].job.corp}</div>
            <div>{section.speakers[0].job.job_title}</div>
            <div style={{ clear: "both", paddingTop: "1rem" }}>
              <ReactMarkdownWithHtml
                allowDangerousHtml={true}
                children={section.speakers[0].description}
              ></ReactMarkdownWithHtml>
            </div>
          </>
        )}
        <div className={style.button}>
          {section.ticket && (
            <a
              style={{ marginBottom: 32 }}
              rel="noreferrer"
              className={"cta"}
              href={section.ticket}
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                focusable="false"
                width="30"
                height="30"
                style={{ verticalAlign: -9 }}
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 32 32"
              >
                <path
                  d="M29 14a1 1 0 0 0 1-1V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v5a1 1 0 0 0 1 1a2 2 0 0 1 0 4a1 1 0 0 0-1 1v5a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1a2 2 0 0 1 0-4zm-1 5.87V24h-7v-3h-2v3H4v-4.13a4 4 0 0 0 0-7.74V8h15v3h2V8h7v4.13a4 4 0 0 0 0 7.74z"
                  fill="#fff"
                />
                <path d="M19 13h2v6h-2z" fill="#fff" />
              </svg>
              報名工作坊
            </a>
          )}
          <a
            rel="noreferrer"
            className={"cta"}
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(
              props.data.site.siteMetadata.siteUrl + props.location.pathname
            )}`}
            target="_blank"
            onClick={e => {
              if (
                share(
                  section.title,
                  section.description,
                  props.data.site.siteMetadata.siteUrl + props.location.pathname
                )
              ) {
                e.preventDefault()
              }
            }}
          >
            <svg
              width="23px"
              height="21px"
              viewBox="0 0 23 21"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                <g
                  id="講者_web_pop"
                  transform="translate(-527.000000, -937.000000)"
                  fillRule="nonzero"
                >
                  <g id="Group-18" transform="translate(0.000000, -94.000000)">
                    <g
                      id="fa-solid:share"
                      transform="translate(527.000000, 1030.000000)"
                    >
                      <g
                        id="Icon"
                        transform="translate(0.000000, 1.000000)"
                        fill="#FFFFFF"
                      >
                        <path
                          d="M22.6267441,7.55026325 L14.7203145,0.774437415 C14.028248,0.18127123 12.9375,0.662803584 12.9375,1.58422852 L12.9375,5.15316746 C5.72174414,5.23515413 0,6.67038893 0,13.4569591 C0,16.1961341 1.77805273,18.9097635 3.74347461,20.3285029 C4.35679297,20.7712487 5.23088281,20.2155762 5.00474609,19.4978919 C2.96780859,13.0328932 5.97088086,11.3165676 12.9375,11.2171047 L12.9375,15.1365489 C12.9375,16.0594005 14.0291016,16.5387929 14.7203145,15.94634 L22.6267441,9.16984545 C23.1240742,8.74355044 23.124748,7.97713782 22.6267441,7.55026325 Z"
                          id="Icon-Path"
                        ></path>
                      </g>
                      <rect
                        id="ViewBox"
                        x="0"
                        y="0"
                        width="23"
                        height="23"
                      ></rect>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            分享這個議程
          </a>
        </div>
      </div>
      <div id="recapacha"></div>
    </>
  )

  return (
    <ModalRoutingContext.Consumer>
      {({ modal, closeTo }) => {
        if (modal) {
          return (
            <Modal>
              <div className={[style.sectionWrap, style.modal].join(" ")}>
                {content}
              </div>
            </Modal>
          )
        } else {
          return (
            <Layout>
              <SEO
                title={
                  section.name && section.name.replace(/(?:\r\n|\r|\n)/g, " ")
                }
                description={
                  section.description &&
                  section.description.replace(/(?:\r\n|\r|\n)/g, " ")
                }
                image={
                  section.og_image &&
                  section.og_image.childImageSharp.original.src
                }
              />
              <div className={[style.sectionWrap, style.page].join(" ")}>
                {content}
              </div>
            </Layout>
          )
        }
      }}
    </ModalRoutingContext.Consumer>
  )
}

export default Section

export const query = graphql`
  query($id: String!) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    allStrapiSession(filter: { id: { eq: $id } }) {
      nodes {
        start_time
        stream
        speakers {
          avatar {
            childImageSharp {
              resize(width: 320) {
                src
                width
                height
                aspectRatio
              }
            }
          }
          description
          job {
            corp
            job_title
          }
          name {
            name
            origional_name
          }
        }
        location
        description
        id
        end_time
        session_type {
          id
          name
        }
        name
        og_image {
          childImageSharp {
            original {
              src
            }
          }
        }
        tag {
          tag
        }
        ticket
      }
    }
    allStrapiWriting(filter: { site: { id: { eq: 2 } } }) {
      edges {
        node {
          key
          writing
          site {
            id
          }
        }
      }
    }
  }
`
